module.exports = __webpack_public_path__ + "img/Turkey.77c320d3.svg";